/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Supplier } from '@app/suppliers/suppliers/suppliers.model';
import { Model } from '@app/shared/models/model.model';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class SuppliersService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/suppliers', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((currency: any) => {
          return new Supplier().deserialize(currency);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(supplier: Supplier): Observable<Supplier> {
    return this.http.put('v1/suppliers/' + supplier.id, supplier).pipe(
      map((response: HttpResponse) => {
        return new Supplier().deserialize(response.data);
      })
    );
  }

  store(supplier: Supplier): Observable<Supplier> {
    return this.http.post('v1/suppliers', supplier).pipe(
      map((response: HttpResponse) => {
        return new Supplier().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/suppliers/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Supplier().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/suppliers/' + id);
  }

  /**
   * @todo това е само пример!!!
   */
  export(query: ApiQuery = new ApiQuery()) {
    return this.http.download('v1/suppliers', query.buildGetOptions()).subscribe((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.ms-excel;charset=utf-8',
      });
      FileSaver.saveAs(blob, 'users.xlsx');
    });
  }
}
